import React, {
  useState,
  useEffect,
  useImperativeHandle,
  forwardRef,
} from "react";
import { GridRowModes } from "@mui/x-data-grid";
import AAutoComplete from "views/pages/manage/common/form-fields-mui/AAutoComplete";
import AInput from "views/pages/manage/common/formFeilds/customInput/AInput";
import { editCellContainerStyle } from "../onBoardingMaterialIdSetup/constant";
import {
  ActionsCellComponent,
  StatusCellComponent,
} from "../../../../masters/studentFinancials/paymentGatewaysConfiguration/common";
import { ReactComponent as CloseIcon } from "assets/img/svg/CloseSquareBlack.svg";
import ADataGrid from "views/pages/manage/common/data-grid/ADataGrid";
import {
  gridStyles,
  gridComponents,
} from "../../../../edpOps/issuanceIDcard/printIdCardAndMapRfid/constant";
import NoRowOverlay from "views/pages/manage/masters/holidayMaster/NoRowOverlay";
import {
  isObjEmpty,
  generateRandomId,
} from "../../../../common/utils/methods/commonMethods/utilityMethod";
import {
  failureToast,
} from "../../../../common/utils/methods/toasterFunctions/function";
import { saveOrDeleteMsg } from "../sapProfitCostCentreMapping/constant";
import { AGridColDef } from "../../../../common/data-grid/ADataGridColDef";
import {
  newRow,
  newServiceRow,
  areAllMandatoryFieldsFilled,
} from "./constants";
import { ReactComponent as DeleteIcon } from "assets/img/svg/Delete.svg";
import { regex } from "views/pages/manage/common/constant/regex/index";
import SelectMaterialElasticSearch from "../onBoardingMaterialIdSetup/SelectMaterialElasticSearch";
import { FaRupeeSign } from "react-icons/fa";

const ServiceListComponent = (
  {
    rows = [],
    loading = false,
    dropdownData,
    createUpdateHandler,
    setRowForm,
    isViewMode,
    listing,
    deleteItemHandler,
    rowForm
  },
  ref
) => {
  const [rowModesModel, setRowModesModel] = useState({});
  const [serviceRowForm, setServiceRowForm] = useState({});
  const [serviceRowData, setServiceRowData] = useState(rows);

  const requiredFields = [
    ...((rowForm?.Item_cat?.value == 'D') ? ["Price", "Cost_Center"] : [])
  ];

  useEffect(() => {
    setServiceRowData(rows);
  }, [rows]);


  /**
   * same function to delete by calling api or delete row from memory
   */
  const handleDelete = (id) => {
    let tempArray = [];
    let newItemNo = 1;
    for (let i = 0; i < serviceRowData.length; i++) {
      if (serviceRowData[i]?.id !== id) {
        let updatedRow = { ...serviceRowData[i], SrvLine: newItemNo };
        tempArray.push(updatedRow);
        newItemNo++;
      }
    }
    setServiceRowData(tempArray);
    setRowForm((prev) => ({ ...prev, Service_Item: tempArray }));
  };

  const rowFormHandler = (value, key) => {
    setServiceRowForm((prev) => ({ ...prev, [key]: value }));
  };

  const startEditing = (id, form) => {
    setRowModesModel((oldModel) => ({ [id]: { mode: GridRowModes.Edit } }));
    setServiceRowForm(form);
  };

  const stopEditing = () => {
    const currForm = { ...serviceRowForm };
    setRowModesModel((oldModel) => ({
      [currForm?.id]: { mode: GridRowModes.View, ignoreModifications: true },
    }));
    setServiceRowForm({});
  };

  const handleEditClick = (params) => {
    if (!isObjEmpty(serviceRowForm)) {
      failureToast(saveOrDeleteMsg);
    } else {
      startEditing(params?.id, params?.row);
    }
  };

  const handleCancelClick = async (params) => {
    if (params?.row?.isNew) {
      setServiceRowData(rows);
      setServiceRowForm({});
    } else {
      stopEditing(params?.id);
    }
  };

  const handleSaveClick = async (params) => {
    createUpdateHandler(serviceRowForm);
  };

  const addNewRow = async () => {
    if (!isObjEmpty(serviceRowForm)) {
      failureToast(saveOrDeleteMsg);
    } else {
      let randomId = generateRandomId();
      let emptyRow = {
        ...newServiceRow,
        isNew: true,
        SrvLine: serviceRowData.length + 1,
        id: randomId,
      };
      startEditing(randomId, emptyRow);
      setServiceRowData((prev) => [...prev, emptyRow]);
    }
  };

  useImperativeHandle(ref, () => ({
    addNewRow: addNewRow,
    startEditing: startEditing,
    stopEditing: stopEditing,
  }));

  const columns = [
    new AGridColDef("SrvLine", "Line No", false)
      .setMinWidth(80)
      .setFlex(1)
      .editable(false)
      .setValueGetter((params) => params?.value)
      .renderEditCellComponent((params) => (
        <div style={editCellContainerStyle}>
          <AInput
            value={serviceRowForm?.SrvLine}
            handler={(val) => {
              rowFormHandler(val, "SrvLine");
            }}
            placeholder={""}
            maxLength={5}
          />
        </div>
      )),
    new AGridColDef("Service_no", "Service Number", false)
      .setMinWidth(80)
      .setFlex(1)
      .editable(true)
      .setValueGetter((params) => params?.value?.label)
      .renderEditCellComponent((params) => (
        <div style={editCellContainerStyle}>
          <SelectMaterialElasticSearch
            currentValue={serviceRowForm?.Service_no}
            handleChange={(value) => {
              rowFormHandler(value, "Service_no");
            }}
            isMulti={false}
            dropdownMappingParams={[
              "serviceNoAndServiceTxt",
              "serviceNo",
              "serviceTxt"
            ]}
            category="ServiceMaster"
            isPlantIdRequired={false}
          />
        </div>
      )),
    new AGridColDef("Quantity", "Quantity", false)
      .setMinWidth(80)
      .setFlex(1)
      .editable(true)
      .setValueGetter((params) => params?.value)
      .renderEditCellComponent((params) => (
        <div style={editCellContainerStyle}>
          <AInput
            value={serviceRowForm?.Quantity}
            handler={(val) => {
              rowFormHandler(val, "Quantity");
            }}
            placeholder={""}
            maxLength={5}
            regex={regex.numeric}
          />
        </div>
      )),
    new AGridColDef("Price", rowForm?.Item_cat?.value === "D" ? "Price*" : "Price", false)
      .setMinWidth(80)
      .setFlex(1)
      .editable(true)
      .setValueGetter((params) => params?.value)
      .renderEditCellComponent((params) => (
        <div style={editCellContainerStyle}>
          <AInput
            value={serviceRowForm?.Price}
            handler={(val) => {
              rowFormHandler(val, "Price");
            }}
            placeholder={""}
            regex={regex.numericDecimal}
            rightCustomIcon={<FaRupeeSign style={{
              fontSize: '13px', top: '3px', right: '5px',
              position: "absolute",
              bottom: "0",
              margin: "auto 0",
              cursor: "not-allowed",
            }}
            />}
          />
        </div>
      )),
    new AGridColDef("Cost_Center", rowForm?.Item_cat?.value === "D" ? "Cost Center*" : "Cost Center", false)
      .setMinWidth(80)
      .setFlex(1)
      .editable(true)
      .setValueGetter((params) => params?.value?.label)
      .renderEditCellComponent((params) => (
        <div style={editCellContainerStyle}>
          <AAutoComplete
            currentValue={serviceRowForm?.Cost_Center}
            handleChange={(value) => {
              rowFormHandler(value, "Cost_Center");
            }}
            items={dropdownData?.sapCostCenter}
            isMulti={false}
            placeholder={"Select"}
            autoFocus={params?.hasFocus}
            isClearable={true}
          />
        </div>
      )),
    new AGridColDef("actions", "Action", false)
      .setMinWidth(90)
      .setFlex(1)
      .editable(true)
      .columnAlign("right")
      .renderCellComponent(
        (params) =>
          (!isViewMode) && (
            <div className="d-flex">
              <ActionsCellComponent
                mode={params.api.getRowMode(params?.id)}
                handleEditClick={handleEditClick}
                params={params}
              />
              {!listing && (
                <div className="mx-2 p-1 cursor">
                  <DeleteIcon
                    className="cursor"
                    onClick={() => {
                      handleDelete(params?.row?.id);
                    }}
                  />
                </div>
              )}
            </div>
          )
      )
      .renderEditCellComponent((params) => (
        <ActionsCellComponent
          mode={"edit"}
          isSaveDisabled={
            !areAllMandatoryFieldsFilled(serviceRowForm, requiredFields)
          }
          handleSaveClick={handleSaveClick}
          handleCancelClick={handleCancelClick}
          params={params}
          cancelIcon={
            <CloseIcon
              className="mx-2 cursor"
              onClick={() => handleCancelClick(params)}
            />
          }
        />
      )),
  ];

  return (
    <>
      <div
        className=""
        style={{ border: "1px solid #EEE", borderRadius: "8px" }}
      >
        <ADataGrid
          removeWrapperContainer
          sx={{
            ...gridStyles,
          }}
          rowModesModel={rowModesModel}
          rows={serviceRowData || []}
          columns={columns}
          rowId={(row) => row.id}
          rowHeight={50}
          loading={false}
          maxHeight={"300px"}
          rowCount={(serviceRowData || []).length}
          hidePagination
          // currentPage={currentPage}
          // nextButtonHandler={pageChangeHandler}
          components={{
            ...gridComponents,
            NoRowsOverlay: () => (
              <NoRowOverlay message={loading ? "Loading..." : null} />
            ),
          }}
        />
      </div>
    </>
  );
};

export default forwardRef(ServiceListComponent);
